package com.nonopn.skywatcher.common.api

import kotlinx.serialization.Serializable

// One generated document (report or certificate), as stored per account by the Strike Radar
// documents history service (o2switch).
@Serializable
data class DocumentsHistoryItem(
    val id: String,
    val type: String,
    val siteName: String,
    val createdAtSecondsUtc: Long,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val impactLat: Double? = null,
    val impactLon: Double? = null,
    val impactTimestamp: Long = 0L,
    val impactAmplitude: Int = 0,
    val impactPercent: Double = 0.0,
    val impactExternalId: String = "",
)

@Serializable
data class DocumentsHistoryRequest(
    val items: List<DocumentsHistoryItem> = emptyList(),
)

@Serializable
data class DocumentsHistoryAnswer(
    val items: List<DocumentsHistoryItem> = emptyList(),
)
